module.exports = __webpack_public_path__ + "c24288f4618942c47f486e67e6649f42.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_1.png
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_1.png
// module chunks = 40